"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.EDataLoadStatus = void 0;
var React = require("react");
var scrollParent_1 = require("mobile/utils/scrollParent");
var throttle_1 = require("utils/throttle");
var abortedPromise_1 = require("mobile/utils/abortedPromise");
var EDataLoadStatus;
(function (EDataLoadStatus) {
    EDataLoadStatus[EDataLoadStatus["ALREADY_LOAD_ALL_DATA"] = 0] = "ALREADY_LOAD_ALL_DATA";
    EDataLoadStatus[EDataLoadStatus["LOADING_DATA"] = 1] = "LOADING_DATA";
    EDataLoadStatus[EDataLoadStatus["LOAD_DATA_FAIL"] = 2] = "LOAD_DATA_FAIL";
    EDataLoadStatus[EDataLoadStatus["WAIT_FOR_TRIGGER_LOAD"] = 3] = "WAIT_FOR_TRIGGER_LOAD";
})(EDataLoadStatus = exports.EDataLoadStatus || (exports.EDataLoadStatus = {}));
var ScrollLoad = (function (_super) {
    __extends(ScrollLoad, _super);
    function ScrollLoad(props) {
        var _this = _super.call(this, props) || this;
        _this.state = {
            dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD,
            prevDataKey: _this.props.dataKey
        };
        _this.initStatus = function (status) {
            _this.setState({ dataLoadStatus: status });
        };
        _this.scrollLoad = function () {
            if (!!_this.stuffsContainer) {
                var parentHeight = window.screen.availHeight;
                var innerRect = _this.stuffsContainer.getBoundingClientRect();
                var orientation = _this.props.orientation;
                var isNeedLoad = (orientation !== "horizontal" && innerRect.bottom < parentHeight * 4) ||
                    (orientation === "horizontal" &&
                        _this.scrollContainerElement.scrollWidth - _this.scrollContainerElement.scrollLeft <
                            _this.scrollContainerElement.offsetWidth * 2);
                if (isNeedLoad && _this.state.dataLoadStatus === EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD) {
                    _this.loadData();
                }
            }
        };
        _this.processLoadError = function (error) {
            if (error !== abortedPromise_1.ABORT_REASON) {
                if (_this.props.needRetryIfError) {
                    _this.setState({ dataLoadStatus: EDataLoadStatus.LOAD_DATA_FAIL });
                }
                else {
                    _this.setState({ dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD });
                }
            }
            _this.cancelPrevLoadPromise = void 0;
        };
        _this.onScrollLoad = throttle_1.default(_this.scrollLoad, 120);
        return _this;
    }
    ScrollLoad.getDerivedStateFromProps = function (nextProps, prevState) {
        if (nextProps.dataKey !== prevState.prevDataKey) {
            return {
                prevDataKey: nextProps.dataKey,
                dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD
            };
        }
        else {
            return prevState;
        }
    };
    ScrollLoad.prototype.componentDidMount = function () {
        this.scrollContainerElement = scrollParent_1.default(this.stuffsContainer);
        this.scrollContainer = document;
        this.scrollContainer.addEventListener("scroll", this.onScrollLoad);
        if (this.props.loadDataWhenDidMount) {
            this.loadData();
        }
    };
    ScrollLoad.prototype.componentDidUpdate = function (_prevProps, prevState) {
        if (this.state.prevDataKey !== prevState.prevDataKey) {
            if (!!this.cancelPrevLoadPromise) {
                this.cancelPrevLoadPromise.abort();
                this.cancelPrevLoadPromise = void 0;
            }
            this.loadData();
        }
    };
    ScrollLoad.prototype.componentWillUnmount = function () {
        if (!!this.scrollContainer) {
            this.scrollContainer.removeEventListener("scroll", this.onScrollLoad);
        }
        if (!!this.cancelPrevLoadPromise) {
            this.cancelPrevLoadPromise.abort();
        }
    };
    ScrollLoad.prototype.loadData = function () {
        var _this = this;
        var loadFunction = this.props.loadFunction;
        if (this.state.dataLoadStatus === EDataLoadStatus.LOADING_DATA) {
            return;
        }
        this.setState({ dataLoadStatus: EDataLoadStatus.LOADING_DATA });
        this.cancelPrevLoadPromise = abortedPromise_1.abortedPromise(loadFunction());
        this.cancelPrevLoadPromise.then(function (_a) {
            var loadCount = _a.loadCount, isError = _a.isError;
            if (loadCount !== -999) {
                if (isError) {
                    _this.processLoadError();
                }
                else {
                    _this.setState({ dataLoadStatus: EDataLoadStatus.WAIT_FOR_TRIGGER_LOAD });
                    _this.cancelPrevLoadPromise = void 0;
                }
            }
        }, this.processLoadError);
    };
    ScrollLoad.prototype.render = function () {
        var _this = this;
        return (React.createElement("div", { ref: function (me) { return (_this.stuffsContainer = me); }, className: this.props.className, "data-panel": "scrollpanel" }, this.props.children));
    };
    ScrollLoad.defaultProps = {
        loadDataWhenDidMount: true,
        needRetryIfError: false,
        isShowLoading: false
    };
    return ScrollLoad;
}(React.Component));
exports.default = ScrollLoad;
